const CATEGORY_ROUTES = Object.freeze({
	category: {
		name: 'Category',
		path: '/category',
		meta: {
			layout: 'Default',
		},
		component: () => import('@/presentation/modules/category/views/CategoryView.vue'),
	},
	categoryItems: {
		name: 'CategoryItems',
		path: '/category/:categoryId/:categoryName',
		component: () => import('@/presentation/modules/category/views/CategoryItemsView.vue'),
	},
});

export default CATEGORY_ROUTES;
